"use client"

import PageDrawerMobile, { PageDrawerMobileRef } from "@/components/common/PageDrawerMobile"
import Text from "@/components/common/Typography/Text"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"

import { faChevronRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Card, Col, Row } from "antd"
import { useMemo, useRef } from "react"
import TourInputBooking from "../TourInputBooking"
import { useTour } from "@/hooks/tour/useTour"
import { useAppSelector } from "@/lib/redux/hooks"
import { useTETranslation } from "@/hooks/app/useTETranslation"
import { useTranslation } from "react-i18next"

export const refDrawerInputBooking: { current: PageDrawerMobileRef | null } = { current: null }

const DISPLAY_PRICE_MARKUP = 1.05

const FooterRequestBookingTour = () => {
  const isDesktop = useIsDesktop()
  const { tour: { data: tour } } = useTour()
  const selectedDepartureSchedule = useAppSelector(
    (state) => state.tour.inputTour.selectedDepartureSchedule
  )
  const { getFormatCurrency } = useTETranslation()
  const { t } = useTranslation()

  const selectedSchedule = useMemo(
    () => tour.departureSchedule?.find((d) => d.id === selectedDepartureSchedule),
    [tour.departureSchedule, selectedDepartureSchedule]
  )

  const unitSalePrice = selectedSchedule?.prices?.[0]?.priceAdt ?? 0
  const unitListPrice = Number.isFinite(unitSalePrice)
    ? Math.round(unitSalePrice * DISPLAY_PRICE_MARKUP)
    : null
  const showStrikethrough =
    Number.isFinite(unitSalePrice) &&
    unitListPrice !== null &&
    unitListPrice > unitSalePrice

  if (isDesktop) {
    return <></>
  }

  return (
    <Row
      className="tour-detail__mobile-footer"
    >
      <PageDrawerMobile
        ref={(curr) => { refDrawerInputBooking.current = curr; }}
        headerProps={{
          title: t("tour.schedule_and_price"),
          shownRight: false
        }}
      >
        <TourInputBooking />
      </PageDrawerMobile>
      <Col span={24}>
        <Card size='small' className="tour-detail__mobile-footer-card">
          <Row justify='space-between' align='middle'>
            <Col>
              <Text type='secondary' className="tour-item__price-label">
                {t("tour.price_only_from")}
              </Text>
              {showStrikethrough && (
                <p className="tour-item__price-old">{getFormatCurrency(unitListPrice!)}</p>
              )}
              <p className="tour-item__price-sale tour-detail__footer-price">
                {getFormatCurrency(unitSalePrice)}
              </p>
            </Col>
            <Col>
              <Button
                size='large'
                type='primary'
                className="tour-item__cta tour-detail__footer-cta tour-detail__cta-primary"
                iconPlacement='end'
                icon={<FontAwesomeIcon icon={faChevronRight} />}
                onClick={() => refDrawerInputBooking.current?.open()}
              >
                {t("tour.book_hold_now")}
              </Button>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  )
}

export default FooterRequestBookingTour